export default "__VITE_ASSET__BtDGYKm___"